function isIOS() {
    const ua = navigator.userAgent;
    return /iPhone|iPad|iPod/i.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
}

function isSafari() {
    const ua = navigator.userAgent;
    return /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
}

function isSafariOrIOS() {
    return isSafari() || isIOS();
}

module.exports = { isSafariOrIOS: isSafariOrIOS };
